import React from 'react';
import { ShieldCheck } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import SecurityStats from '../components/dashboard/SecurityStats';
import AlertList from '../components/dashboard/AlertList';
import CredentialManager from '../components/credentials/CredentialManager';
import ActivityLog from '../components/dashboard/ActivityLog';
import { 
  usuariosMock, 
  credencialesMock, 
  alertasMock, 
  estadisticasMock,
  actividadRecienteMock
} from '../data/mockData';

interface DashboardProps {
  onLogout: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({ onLogout }) => {
  // Usar el primer usuario como ejemplo (en una aplicación real, sería el usuario autenticado)
  const usuarioActual = usuariosMock[0];

  return (
    <div className="flex flex-col min-h-screen text-white bg-cyber-dark">
      <Header usuario={usuarioActual} onLogout={onLogout} />
      
      <main className="flex-1 p-4 md:p-6">
        <div className="max-w-7xl mx-auto">
          {/* Encabezado del panel */}
          <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="mb-4 md:mb-0">
              <h2 className="text-2xl font-bold text-white flex items-center">
                <ShieldCheck className="h-6 w-6 mr-2 text-cyber-blue" />
                Panel de Control de Seguridad
              </h2>
              <p className="text-cyber-light">
                Última sincronización: {new Date().toLocaleString('es-ES')}
              </p>
            </div>
            
            <div className="flex flex-wrap gap-2">
              <button className="px-4 py-2 bg-cyber-blue hover:bg-cyber-blue/80 text-white rounded-md text-sm transition-colors duration-200">
                Ejecutar Análisis
              </button>
              <button className="px-4 py-2 bg-cyber-gray/30 hover:bg-cyber-gray/50 text-white rounded-md text-sm transition-colors duration-200">
                Generar Informe
              </button>
            </div>
          </div>
          
          {/* Tablero principal */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Columna 1 */}
            <div className="space-y-6">
              <SecurityStats stats={estadisticasMock} />
              <ActivityLog actividades={actividadRecienteMock} />
            </div>
            
            {/* Columna 2 */}
            <div className="space-y-6">
              <AlertList alertas={alertasMock} />
            </div>
            
            {/* Columna 3 */}
            <div>
              <CredentialManager credenciales={credencialesMock} />
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Dashboard;